export function checkPosDecent(s: string): boolean {
  if(s === "CashierRole" ||
  (s === "RequireTenantBranchManager") ||
  (s === "ManagerBranchWarehouseRole") ||
  (s === "RequireTenantManagerRole")
  ){
    return true
  }
  return false;
}
